import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentDetailsCard } from '@features/invoices/elements/DocumentDetailsCard'
import { EInvoiceStatusTag } from '@features/invoices/elements/EInvoiceStatusTag'
import { EInvoiceStatus } from '@features/invoices/enums/eInvoiceStatus'
import { getEInvoiceStatusConfig } from '@features/invoices/utils/eInvoices/getEInvoiceStatusConfig'

import * as Styled from './styles'

export const DemoInvoiceSentEInvoiceStatusCard = (): ReactElement | null => {
  const { t } = useTranslation()
  const config = getEInvoiceStatusConfig(EInvoiceStatus.Sent)

  if (!config) {
    return null
  }

  const { detailedDescriptionTKey, icon, labelTKey, shortDescriptionColor, shortDescriptionTKey, tagColor } = config

  return (
    <DocumentDetailsCard isLoading={false} title={t('external_invoices.view.sidebar.einvoice_details_card.title')}>
      <Styled.StatusCardHeader>
        <Flex flexDirection="column" gap={Spacing.S8}>
          <Flex.Item alignSelf="flex-start">
            <EInvoiceStatusTag color={tagColor} icon={icon} label={t(labelTKey)} />
          </Flex.Item>
          {shortDescriptionTKey && (
            <Text color={shortDescriptionColor} variant="bodySM">
              {t(shortDescriptionTKey)}
            </Text>
          )}
        </Flex>
      </Styled.StatusCardHeader>
      {detailedDescriptionTKey && (
        <DocumentDetailsCard.Entry title={t('external_invoices.view.sidebar.einvoice_details_card.description_label')}>
          <Text variant="bodySM">{t(detailedDescriptionTKey)}</Text>
        </DocumentDetailsCard.Entry>
      )}
    </DocumentDetailsCard>
  )
}
